import React from "react";
import useNavbarLogic from "./hooks/useNavbarLogic";
import NavbarDesktop from "./components/NavbarDesktop";
import NavbarMobile from "./components/NavbarMobile";

function Navbar() {
  const { screenSize } = useNavbarLogic();

  return screenSize === "mobile" ? <NavbarMobile /> : <NavbarDesktop />;
}

export default Navbar;
